export default "__VITE_ASSET__1NkkfA_e__"